<div class="faq-helpdesk-main">
  <div class="top-content">
    <h3>{{ 'faq.need-help-headline' | translate }}</h3>
    <p class="medium-text">{{ 'faq.use-ai' | translate }}</p>
    <div class="center">
      <coin-chat-bot></coin-chat-bot>
    </div>

    @if (faqItem()) {
      <p class="medium-text">{{ 'faq.search-in-faq' | translate }}</p>
      <div>
        <coin-siemens-energy-faq-inbetween-level
          class="faq-base-tab"
          [items]="faqItem()"
          (openFaq)="openFaq.emit($event)"></coin-siemens-energy-faq-inbetween-level>
      </div>
    }
  </div>

  <div class="bottom-content">
    <h4>{{ 'faq.nothing-found' | translate }}</h4>
    <coin-v2-button
      class="create-ticket-button"
      type="secondary"
      icon="chevron_right"
      iconPos="right"
      (click)="openHelpdesk()">
      {{ 'faq.create-ticket' | translate }}
    </coin-v2-button>
  </div>
</div>
